import script from "./IndexPhpEolDismissedRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexPhpEolDismissedRecords.vue?vue&type=script&setup=true&lang=js"

import "./IndexPhpEolDismissedRecords.vue?vue&type=style&index=0&id=29f0fbcf&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29f0fbcf"]])

export default __exports__